var _path, _path2, _g, _rect, _rect2, _g2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path3, _path4, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_56",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 82,
    width: 152,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_56)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 180,
    height: 38,
    fill: "black",
    fillOpacity: 0.1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 130,
    height: 120,
    rx: 18,
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_56",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 130,
    height: 120,
    rx: 18,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_56)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 134,
    height: 124,
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8805 165.092C19.2414 134.402 27.938 160.534 48.8656 155.124C58.1115 152.734 50.641 142.296 57.537 137.772C63.3619 133.95 71.2998 137.029 77.9722 134.558C87.6015 130.991 87.4749 123.735 96.447 122.651C104.932 121.625 113.82 125.005 122.378 123.735C138.528 121.339 131.906 89.7111 144.017 84.1252C156.129 78.5392 176.068 88.1858 178.678 104C181.222 119.417 164.22 176.78 164.22 176.78H14.8805",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9269 165C97.6044 165 101.527 150.25 120.065 143.493C138.603 136.735 154.846 154.214 161.078 137.233C167.31 120.253 167.276 173.181 167.276 173.181H59.9269L59.9269 165Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 47.8673C33.7332 46.7465 29.9619 59.8061 34.5974 59.8061C36.4464 59.8061 38.6253 51.3489 41.9832 51.3489C44.438 51.3489 43.9753 56.8425 49.305 56.2617C54.3077 55.7166 53.3754 52.2687 55.9027 52.2687C61.3454 52.2687 59.2873 72.4636 63.6441 72.4636C68.0009 72.4636 69.3737 57.668 71.2914 51.8164C73.7181 44.4119 88.2635 40.2616 77.8923 37.3201H21.7133",
    fill: "black",
    fillOpacity: 0.4
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 129,
    width: 68,
    height: 22,
    rx: 5,
    fill: "black",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 133,
    width: 60,
    height: 14,
    rx: 2,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 86C38 81.5817 41.5817 78 46 78H134C138.418 78 142 81.5817 142 86V104C142 108.418 138.418 112 134 112H120.981C117.711 112.167 115.5 113.137 114.005 114.347C113.518 114.741 113.024 115.163 112.522 115.593C110.047 117.708 107.365 120 104.278 120H90H76.6676C73.5324 120 70.732 117.871 68.0462 115.829L68.0461 115.829C67.096 115.106 66.1602 114.395 65.229 113.792C63.7725 112.85 61.7704 112.141 59.0192 112H46C41.5817 112 38 108.418 38 104V86Z",
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_56",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 78,
    width: 104,
    height: 42
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 86C38 81.5817 41.5817 78 46 78H134C138.418 78 142 81.5817 142 86V104C142 108.418 138.418 112 134 112H120.981C117.711 112.167 115.5 113.137 114.005 114.347C113.518 114.741 113.024 115.163 112.522 115.593C110.047 117.708 107.365 120 104.278 120H90H76.6676C73.5324 120 70.732 117.871 68.0462 115.829L68.0461 115.829C67.096 115.106 66.1602 114.395 65.229 113.792C63.7725 112.85 61.7704 112.141 59.0192 112H46C41.5817 112 38 108.418 38 104V86Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_56)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 95C50 92.2386 52.2386 90 55 90H125C127.761 90 130 92.2386 130 95V97C130 99.7614 127.761 102 125 102H112.981C109.711 102.167 107.5 103.137 106.005 104.347C105.518 104.741 105.024 105.163 104.522 105.593C102.518 107.305 100.38 109.133 98 109.767V110H96.2779H90H84.6676C81.5324 110 78.732 107.871 76.0462 105.829L76.0461 105.829C75.096 105.106 74.1602 104.395 73.229 103.792C71.7725 102.85 69.7704 102.141 67.0192 102H55C52.2386 102 50 99.7614 50 97V95Z",
    fill: "#FF3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 120L70 74H66L46 120H50ZM88 74H77L57 120H68L88 74Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot8);
export default __webpack_public_path__ + "static/media/bot-8.8191c807960d4e0d7ca65e0f9166074f.svg";
export { ForwardRef as ReactComponent };